export const static_errors = {
  vital_parsing_error:
    'There was an error retrieving vital settings, please contact support.',
  unexpected_contact_support:
    'An unexpected error occurred. Please contact support if this occurs again.',
} as const

export const global_error_codes = {
  program_applications_not_found: 16,
  invitation_expired: 23,
} as const

export const usStates = [
  { abbreviation: 'AL', name: 'Alabama' },
  { abbreviation: 'AK', name: 'Alaska' },
  { abbreviation: 'AZ', name: 'Arizona' },
  { abbreviation: 'AR', name: 'Arkansas' },
  { abbreviation: 'CA', name: 'California' },
  { abbreviation: 'CO', name: 'Colorado' },
  { abbreviation: 'CT', name: 'Connecticut' },
  { abbreviation: 'DE', name: 'Delaware' },
  { abbreviation: 'FL', name: 'Florida' },
  { abbreviation: 'GA', name: 'Georgia' },
  { abbreviation: 'HI', name: 'Hawaii' },
  { abbreviation: 'ID', name: 'Idaho' },
  { abbreviation: 'IL', name: 'Illinois' },
  { abbreviation: 'IN', name: 'Indiana' },
  { abbreviation: 'IA', name: 'Iowa' },
  { abbreviation: 'KS', name: 'Kansas' },
  { abbreviation: 'KY', name: 'Kentucky' },
  { abbreviation: 'LA', name: 'Louisiana' },
  { abbreviation: 'ME', name: 'Maine' },
  { abbreviation: 'MD', name: 'Maryland' },
  { abbreviation: 'MA', name: 'Massachusetts' },
  { abbreviation: 'MI', name: 'Michigan' },
  { abbreviation: 'MN', name: 'Minnesota' },
  { abbreviation: 'MS', name: 'Mississippi' },
  { abbreviation: 'MO', name: 'Missouri' },
  { abbreviation: 'MT', name: 'Montana' },
  { abbreviation: 'NE', name: 'Nebraska' },
  { abbreviation: 'NV', name: 'Nevada' },
  { abbreviation: 'NH', name: 'New Hampshire' },
  { abbreviation: 'NJ', name: 'New Jersey' },
  { abbreviation: 'NM', name: 'New Mexico' },
  { abbreviation: 'NY', name: 'New York' },
  { abbreviation: 'NC', name: 'North Carolina' },
  { abbreviation: 'ND', name: 'North Dakota' },
  { abbreviation: 'OH', name: 'Ohio' },
  { abbreviation: 'OK', name: 'Oklahoma' },
  { abbreviation: 'OR', name: 'Oregon' },
  { abbreviation: 'PA', name: 'Pennsylvania' },
  { abbreviation: 'RI', name: 'Rhode Island' },
  { abbreviation: 'SC', name: 'South Carolina' },
  { abbreviation: 'SD', name: 'South Dakota' },
  { abbreviation: 'TN', name: 'Tennessee' },
  { abbreviation: 'TX', name: 'Texas' },
  { abbreviation: 'UT', name: 'Utah' },
  { abbreviation: 'VT', name: 'Vermont' },
  { abbreviation: 'VA', name: 'Virginia' },
  { abbreviation: 'WA', name: 'Washington' },
  { abbreviation: 'WV', name: 'West Virginia' },
  { abbreviation: 'WI', name: 'Wisconsin' },
  { abbreviation: 'WY', name: 'Wyoming' },
] as const

export const americanBanks = [
  { abbreviation: 'JPM', name: 'JPMorgan Chase & Co.' },
  { abbreviation: 'BAC', name: 'Bank of America' },
  { abbreviation: 'C', name: 'Citigroup Inc.' },
  { abbreviation: 'WFC', name: 'Wells Fargo & Co.' },
  { abbreviation: 'GS', name: 'Goldman Sachs Group Inc.' },
  { abbreviation: 'MS', name: 'Morgan Stanley' },
  { abbreviation: 'USB', name: 'U.S. Bancorp' },
  { abbreviation: 'PNC', name: 'PNC Financial Services' },
  { abbreviation: 'TFC', name: 'Truist Financial Corporation' },
  { abbreviation: 'CAP', name: 'Capital One Financial Corp.' },
  { abbreviation: 'AMEX', name: 'American Express' },
  { abbreviation: 'ALLY', name: 'Ally Financial' },
  { abbreviation: 'CIT', name: 'CIT Group' },
  { abbreviation: 'HUNT', name: 'Huntington Bancshares' },
  { abbreviation: 'KEY', name: 'KeyCorp' },
] as const

export const priorityLevels = [
  { id: 1, label: 'Returning students' },
  { id: 2, label: 'Low income students(under 200%)' },
  { id: 3, label: 'Returning students siblings' },
  { id: 4, label: 'Low income students(200% - 555%)' },
  { id: 5, label: 'Default group' },
]

export const constants = {
  errors: {
    auth: {
      unauthorized: 401,
    },
  },
  localstore: {
    access_token: 'auth_token',
  },
}

export enum FETCH_STATUS {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export const ENV = { ...import.meta.env } as const

export const urls = {
  ace_access: {
    registration_invite: ENV.VITE_ACE_ACCESS_URL + '/registration_invite',
  },
}

export const global_on = {
  portal: ENV.VITE_GLOBAL_ON_ID,
}

export const notAllowedRoles = ['family_applicant']

export const INFORMATION_NOT_ENTERED_TEXT = 'Not Specified'

export const LOG_TYPES = {
  REGISTER: 'register',
  START: 'start',
  VIEW_PAGE: 'view_page',
  UPDATE: 'update',
  ADD: 'add',
  UPLOAD_DOCUMENT: 'upload_document',
  DELETE: 'delete',
} as const

export const inceptionStatus = {
  new: 0,
  family_renewal: 3,
}

export const historyType = {
  applicant: 1,
  user: 2,
  provider: 3,
}

/**
 * Global task type ids. The /tasks list is a unified router for pending tasks
 * of every kind; the reference/action are derived from this value together
 * with `related_entity_id` (the morph entity related to the task, e.g.
 * application_flag_id, payment_id or provider_item_id).
 */
export const GLOBAL_TASK_TYPE = {
  APPLICATION_FLAG: 1,
  APPLICATION_APPEAL: 2,
  PAYMENT: 3,
  PROVIDER_ITEM: 4,
} as const

// Options for the task list single-selection filter (sent as `task_type_id`).
export const TASK_TYPE_OPTIONS = [
  { id: GLOBAL_TASK_TYPE.APPLICATION_FLAG, label: 'Application Flag' },
  { id: GLOBAL_TASK_TYPE.APPLICATION_APPEAL, label: 'Application Appeal' },
  { id: GLOBAL_TASK_TYPE.PAYMENT, label: 'Payment' },
  { id: GLOBAL_TASK_TYPE.PROVIDER_ITEM, label: 'Provider Item' },
] as const

export const MAX_UPLOAD_FILE_SIZE_MB = 10
export const MAX_UPLOAD_FILE_SIZE = MAX_UPLOAD_FILE_SIZE_MB * 1024 * 1024

export const SUPPORT_EMAIL = 'support@acescholarships.org'
export const SUPPORT_PHONE = 19858003950
export const SUPPORT_PHONE_FORMATTED = SUPPORT_PHONE.toString().replace(
  /^1?(\d{3})(\d{3})(\d{4})$/,
  '($1) $2-$3'
)
